(() => {
  if (document.documentElement.hasAttribute('data-w-calculators-v3-bound')) return;
  document.documentElement.setAttribute('data-w-calculators-v3-bound', 'true');

  const timeEstimate = (cards, manualSeconds, digitalSeconds) => {
    const manual = cards * manualSeconds / 60;
    const digital = cards * digitalSeconds / 60;
    const difference = manual - digital;
    const scale = Math.max(manual, digital);
    return {
      manual, digital, difference,
      percentage: manual > 0 ? Math.abs(difference / manual * 100) : null,
      manualWidth: scale > 0 ? manual / scale * 100 : 0,
      digitalWidth: scale > 0 ? digital / scale * 100 : 0,
      state: difference > 0 ? 'reduced' : difference < 0 ? (manual > 0 ? 'increased' : 'zero') : 'same'
    };
  };

  const paperEstimate = (team, cards) => {
    const avoided = team * cards;
    const scale = avoided / 2600;
    return {
      avoided,
      weight: scale * 4.68,
      carbon: scale * (4.45 + 0.05837),
      trees: scale * 0.13,
      energy: scale * 259.55,
      energy_kwh: scale * 259.55 / 3.6,
      digital: scale * 0.62
    };
  };

  const roots = new Set();
  const number = (value, digits = 1) => new Intl.NumberFormat(document.documentElement.lang.startsWith('zh') ? 'zh-HK' : 'en-HK', { maximumFractionDigits: digits }).format(value);
  const impactNumber = (value, digits = 2) => value > 0 && value < 0.001 ? '< 0.001' : number(value, value > 0 && value < 1 ? 3 : digits);
  const outputs = (root, values) => root.querySelectorAll('[data-w-output]').forEach((element) => { element.textContent = values[element.dataset.wOutput] ?? '—'; });
  const values = (root, names) => {
    let valid = true;
    const result = names.map((name) => {
      const input = root.querySelector(`[data-w-input="${name}"]`);
      if (!input) { valid = false; return null; }
      const current = input.valueAsNumber;
      const accepted = input.value.trim() !== '' && input.validity.valid && Number.isFinite(current) && Number.isInteger(current) && current >= 0;
      input.setAttribute('aria-invalid', String(!accepted));
      if (!accepted) valid = false;
      return current;
    });
    root.querySelectorAll('[data-w-error]').forEach((error) => { error.hidden = valid; });
    return valid ? result : null;
  };

  const updateTime = (root) => {
    const inputs = values(root, ['cards', 'manual', 'digital']);
    const result = inputs ? timeEstimate(...inputs) : null;
    outputs(root, result ? {
      manual: number(result.manual), digital: number(result.digital),
      difference: number(Math.abs(result.difference)),
      percentage: result.percentage === null ? '—' : number(result.percentage)
    } : {});
    root.querySelectorAll('[data-w-bar]').forEach((bar) => { bar.style.width = `${result ? result[`${bar.dataset.wBar}Width`] : 0}%`; });
    root.querySelectorAll('[data-w-result-state]').forEach((element) => { element.hidden = !result || element.dataset.wResultState !== (result.difference < 0 ? 'additional' : 'saved'); });
    root.querySelectorAll('[data-w-percent-state]').forEach((element) => { element.hidden = !result || element.dataset.wPercentState !== result.state; });
    root.querySelectorAll('[data-w-percentage-value]').forEach((element) => { element.hidden = !result || !['reduced', 'increased'].includes(result.state); });
    const resultBox = root.querySelector('[data-w-time-result]');
    if (resultBox) {
      resultBox.classList.toggle('w-no-saving', !!result && result.difference < 0);
      resultBox.dataset.wInvalid = String(!result);
    }
  };

  const updatePaper = (root) => {
    const inputs = values(root, ['team', 'cards']);
    const result = inputs ? paperEstimate(...inputs) : null;
    outputs(root, result ? {
      avoided: number(result.avoided), weight: impactNumber(result.weight, 1),
      carbon: impactNumber(result.carbon), trees: impactNumber(result.trees),
      energy: impactNumber(result.energy, 1), energy_kwh: impactNumber(result.energy_kwh, 1),
      digital: impactNumber(result.digital)
    } : {});
  };

  const update = (root) => root.dataset.wCalculator === 'time' ? updateTime(root) : updatePaper(root);
  const initialise = (scope = document) => {
    roots.forEach((root) => { if (!root.isConnected) roots.delete(root); });
    if (scope instanceof Element && scope.matches('[data-w-calculator]')) roots.add(scope);
    scope.querySelectorAll('[data-w-calculator]').forEach((root) => roots.add(root));
    roots.forEach(update);
  };
  document.addEventListener('input', (event) => {
    if (!(event.target instanceof Element) || !event.target.matches('[data-w-input]')) return;
    const root = event.target.closest('[data-w-calculator]');
    if (root) update(root);
  });
  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element) || !event.target.matches('[data-w-input]')) return;
    const root = event.target.closest('[data-w-calculator]');
    if (root) update(root);
  });
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    roots.forEach((root) => { if (event.target.contains(root)) roots.delete(root); });
  });
  new MutationObserver(() => roots.forEach(update)).observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  else initialise();
})();
